import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { Types } from './types';

// ACTIONS
import { formaAquisicaoSuccess, formaAquisicaoFailure } from './actions';

function* formaAquisicaoRequest() {
	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`dominios-crm/${CHANNEL}/formas-aquisicao`,
		{},
	);

	if (response.status === 200) {
		yield put(formaAquisicaoSuccess(response));
	} else {
		yield put(formaAquisicaoFailure(response));
	}
}

export default all([
	takeLatest(Types.FORMA_AQUISICAO_REQUEST, formaAquisicaoRequest),
]);
